/* src/app/components/payroll/timesheets/timesheet-view/timesheet-view.component.css */
.provider-section {
  padding-left: 15px;
  font-size: 16px !important;
  margin-bottom: 20px;
}
.font-weight-600 {
  font-weight: 600;
}
:host ::ng-deep tr:has(> td.no-split-entries) > td.expand-row .expand-row-icon-btn {
  visibility: hidden;
  pointer-events: none;
}
/*# sourceMappingURL=timesheet-view.component-LN6TFIZQ.css.map */
